"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.linkStyles = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const classnames_1 = __importDefault(require("classnames"));
const Link_1 = __importDefault(require("@mui/material/Link"));
const shared_styles_1 = require("../common/shared-styles");
exports.linkStyles = (0, styled_components_1.css) `
  &:before {
    border: 1px solid transparent;
    border-radius: ${({ theme }) => theme.constants.borderRadius};
    content: "";
    position: absolute;
    top: -3px;
    right: -3px;
    bottom: -3px;
    left: -3px;
  }

  &.Mui-focusVisible:before {
    box-shadow: ${({ theme }) => theme.constants.focusBoxShadow};
  }

  &:hover {
    color: ${({ theme }) => theme.palette.blue[70]};
  }

  &:active {
    color: ${({ theme }) => theme.palette.blue[80]};

    &:before {
      border-color: ${({ theme }) => theme.palette.blue[80]};
    }
  }
`;
const StyledLink = (0, styled_components_1.default)(Link_1.default) `
  ${shared_styles_1.baseButtonStyles};
  color: ${({ theme }) => theme.palette.primary.main};
  position: relative;

  ${exports.linkStyles};

  &.disabled {
    ${shared_styles_1.disabledButtonStyles};

    &:before {
      border-color: transparent;
    }
  }

  &.disabled:active {
    pointer-events: none;
    font-weight: normal;
    animation: none;
    border-color: transparent;
  }
`;
/**
 * _Text Link_
 *
 * Text links are only used within a body of text or paragraph.
 * Text links should be underlined on hover to indicate the presence of a link.
 *
 */
const Link = ({ disabled, onClick, ...rest }) => ((0, jsx_runtime_1.jsx)(StyledLink, { ...rest, "aria-disabled": disabled, className: (0, classnames_1.default)({ disabled }, rest.className), onClick: disabled ? undefined : onClick, tabIndex: disabled ? -1 : undefined, underline: "always" }));
exports.default = Link;
//# sourceMappingURL=index.js.map